// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App__root___sUZA1{min-height:100vh;display:flex;flex-direction:column}.App__appWrapper____7zwq{flex:1 0}`, "",{"version":3,"sources":["webpack://./src/component/App/App.scss"],"names":[],"mappings":"AAAA,mBACE,gBAAA,CACA,YAAA,CACA,qBAAA,CAGF,yBACE,QAAA","sourcesContent":[".root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.appWrapper {\n  flex: 1 0;\n}\n"],"sourceRoot":""}]);
// Exports
export var root = `App__root___sUZA1`;
export var appWrapper = `App__appWrapper____7zwq`;
export default ___CSS_LOADER_EXPORT___;
